import { AdminAuthenticationApiService } from '@api/admin/services/auth'
import { PackagesApiService } from '@api/admin/services/packages'

export const Auth = new AdminAuthenticationApiService()

export const Packages = new PackagesApiService()
